import m from "../../geodata/es2015/saudiArabiaHigh";
window.am4geodata_saudiArabiaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/saudiArabiaHigh.js
// module id = null
// module chunks = 